import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authContext';

const AuthRedirectHandler = ({ children }) => {
  const { shouldRedirectToLogin, resetRedirectFlag } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldRedirectToLogin) {
      resetRedirectFlag();
      navigate('/login');
    }
  }, [shouldRedirectToLogin, resetRedirectFlag, navigate]);

  return children;
};

export default AuthRedirectHandler;